import { useEffect, useMemo, useRef } from "react";

export const useWaitFor = (isReady: boolean | string | number) => {
  const ref = useRef<any>();
  const getWaitFor = useMemo(
    () => (limit?: number) => {
      return new Promise<boolean | string | number>((resolve, reject) => {
        let timeout = 0;

        if (limit) {
          timeout = window.setTimeout(() => {
            reject("Timeout error!");
          }, limit);
        }

        if (isReady) {
          resolve(isReady);
          window.clearTimeout(timeout);
        } else {
          ref.current = resolve;
        }
      });
    },
    [isReady]
  );

  useEffect(() => {
    if (isReady && ref.current) {
      ref.current(isReady);
    }
  }, [isReady]);

  return getWaitFor;
};
